import { boolean, object, SchemaOf } from "yup";
import { sanitizeFileName } from "@epcnetwork/core-ui-kit";

import { emailColumnValidation, headersValidation, selectMultipleValidation } from "utils";
import { requiredFieldText } from "constants/form.constants";
import { csvFormat, txtFormat } from "constants/file.constants";
import { MatchFileData, MatchValues } from "./match.types";

export const supportedFormats = [csvFormat, txtFormat].flat();

export const validationSchema: SchemaOf<MatchValues> = object({
  fileValues: object({
    emailIndex: emailColumnValidation(),
    headers: headersValidation(),
    databases: selectMultipleValidation(),
    suppress: boolean().required(),
  }).required(requiredFieldText),
});

export const getInitialData = (item: File): MatchFileData => ({
  fileName: sanitizeFileName(item.name),
  headers: [],
  emailIndex: -1,
  databases: [],
  suppress: true,
});
